/**
 * Schema-driven step form types for the Risikoanalyse-Step form.
 *
 * - A "section" is one of the top-level groups in the sidebar
 *   (Unternehmensinformation, Sachwerte, Haftung, Menschen,
 *   Liquidität/Ertragsausfall, Erwartungshaltung).
 * - A "sub-step" is one screen of questions within a section
 *   (e.g. "Allgemeine Informationen", "Vermögenswerte").
 * - A "question" is the actual user-visible question with one
 *   input below it. Multi-input questions live as an array of
 *   `inputs` under a single question.
 */
export const DOKUMENT_STATUS_WERTE = [
    { value: "liegt_vor", label: "liegt vor" },
    { value: "offen", label: "wird eingeholt" },
    { value: "entfaellt", label: "nicht erforderlich" },
];
